<template>
  <div
    style="min-width: 1200px; min-height: 100%; background: linear-gradient(90deg, #01091C, #01152D, #01091C);"
  >
    <a-row :gutter="[15, 15]" style="margin: 0;">
      <a-col :span="24" class="screenHead">
        <h1>易船货平台数据大屏</h1>
        <span class="userInfo">
          {{date}}
          {{time}}
          &nbsp;&nbsp;
          <a-icon type="user" />
          {{userName}}
        </span>
      </a-col>

      <a-col :span="8" class="dataDisplay">
        <div class="dataBox">
          <a-col :span="12">
            <p>货主总数</p>
            <flot :num="info1.cargoOwnerCount || 0" />
          </a-col>
          <a-col :span="12">
            <p>船舶总数</p>
            <flot :num="info1.shipCount || 0" />
          </a-col>
          <a-col :span="12">
            <p>货盘总数</p>
            <flot :num="info1.cargoGoodsCount || 0" />
          </a-col>
          <a-col :span="12">
            <p>船期总数</p>
            <flot :num="info1.shipDateCount || 0" />
          </a-col>
        </div>
        <div class="dataBox dataBox2">
          <a-col :span="24">
            <h2>总利润（元）</h2>
            <span style="font-size: 1rem">{{info1.totalProfit || 0}}</span>
          </a-col>
          <a-col :span="12">
            <p>完成总订单数（笔）</p>
            <span>{{info1.completedOrderCount || 0}}</span>
          </a-col>
          <a-col :span="12">
            <p>完成总货量（吨）</p>
            <span>{{info1.completedVolume ? info1.completedVolume.toFixed(3) : '0.000'}}</span>
          </a-col>
        </div>
      </a-col>
      <!-- 海图 -->
      <a-col :span="8" class="dataDisplay">
        <div id="map" class="orderMap"></div>
      </a-col>
      <a-col :span="8" class="dataDisplay">
        <div class="dataBox">
          <a-col :span="12">
            <p>当前进行中订单数（笔）</p>
            <span>{{info1.goingOrderCount || 0}}</span>
          </a-col>
          <a-col :span="12">
            <p>当前进行中货量（吨）</p>
            <span>{{info1.goingVolume ? info1.goingVolume.toFixed(3) : '0.000'}}</span>
          </a-col>
          <a-col :span="12">
            <p>当前监装任务（单）</p>
            <span>{{info1.loadTaskCount || 0}}</span>
          </a-col>
          <a-col :span="12">
            <p>当前监卸任务（单）</p>
            <span>{{info1.unloadTaskCount || 0}}</span>
          </a-col>
        </div>
        <div class="dataBox dataBox2">
          <a-col :span="12">
            <p>今日新增订单数（笔）</p>
            <span>{{info1.todayOrderCount || 0}}</span>
          </a-col>
          <a-col :span="12">
            <p>今日新增货量（吨）</p>
            <span>{{info1.todayVolume ? info1.todayVolume.toFixed(3) : '0.000'}}</span>
          </a-col>
          <a-col :span="12">
            <p>今日装船量（吨）</p>
            <span>{{info1.todayLoadVolume ? info1.todayLoadVolume.toFixed(3) : '0.000'}}</span>
          </a-col>
          <a-col :span="12">
            <p>今日卸船量（吨）</p>
            <span>{{info1.todayUnloadVolume ? info1.todayUnloadVolume.toFixed(3) : '0.000'}}</span>
          </a-col>
        </div>
      </a-col>

      <a-col :span="16" class="dataDisplay">
        <div class="dataBox dataBox3" style="height: 305px; margin-top: 24px;">
          <h2 class="dataBoxTitle">订单数量趋势</h2>
          <div id="line" class="orderClass"></div>
        </div>
      </a-col>
      <a-col :span="8" class="dataDisplay">
        <div class="dataBox dataBox4" style="height: 305px; margin-top: 24px;">
          <h2 class="dataBoxTitle">项目情况</h2>
          <a-row v-if="projectData && projectData.length > 0" style="width: 100%; color: white;">
            <div class="projectList" v-for="(item, i) in projectData" :key="i">
              <a-col :span="8" class="textEllipsis">{{item.projectName}}</a-col>
              <a-col :span="9">
                <a-progress
                  strokeColor="#F59A23"
                  :percent="parseFloat(item.projectSpeed) || 0"
                  :showInfo="false"
                />
              </a-col>
              <a-col :span="3">&nbsp;{{item.projectSpeed || 0}}%</a-col>
              <a-col :span="4" style=" text-align: right;">
                <img
                  :src="chartPng"
                  @click="viewProject(item.id)"
                  style="cursor: pointer; vertical-align: baseline"
                />
              </a-col>
            </div>
          </a-row>
          <a-empty :image="simpleImage" v-if="!projectData || projectData.length === 0" />
        </div>
      </a-col>
    </a-row>

    <!-- 船信息 -->
    <a-modal v-model="visible" title="船信息" width="600px" @cancel="handleCancel" :footer="null">
      <a-descriptions :column="2">
        <a-descriptions-item label="船名">{{shipInfo.name}}</a-descriptions-item>
        <a-descriptions-item label="呼号">{{shipInfo.callsign}}</a-descriptions-item>
        <a-descriptions-item label="MMSI">{{shipInfo.mmsi}}</a-descriptions-item>
        <a-descriptions-item label="IMO">{{shipInfo.imo}}</a-descriptions-item>
        <a-descriptions-item label="类型">{{shipInfo.type || '--'}}</a-descriptions-item>
        <a-descriptions-item label="状态">{{shipInfo.navistatus || '--'}}</a-descriptions-item>
        <a-descriptions-item label="船长">{{shipInfo.length}}米</a-descriptions-item>
        <a-descriptions-item label="船宽">{{shipInfo.width}}米</a-descriptions-item>
        <a-descriptions-item label="吃水">{{shipInfo.draught}}米</a-descriptions-item>
        <a-descriptions-item label="经度">{{shipInfo.lon}}度</a-descriptions-item>
        <a-descriptions-item label="纬度">{{shipInfo.lat}}度</a-descriptions-item>
        <a-descriptions-item label="船首向">{{shipInfo.hdg}}度</a-descriptions-item>
        <a-descriptions-item label="航迹向">{{shipInfo.cog}}度</a-descriptions-item>
        <a-descriptions-item label="航速">{{shipInfo.sog}}节</a-descriptions-item>
        <a-descriptions-item label="目的地">{{shipInfo.dest || '--'}}</a-descriptions-item>
        <a-descriptions-item label="海区">{{shipInfo.seaareaid || '--'}}</a-descriptions-item>
        <a-descriptions-item label="预到时间">{{shipInfo.eta_std || '--'}}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{shipInfo.lasttime}}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
import store from 'store'
import moment from 'moment'

import chartPng from '@/../static/images/chart.png'
import util from '@/common/util'
import flot from './flot'
import { SHIP_KEY } from '@/common/config'
import { Empty } from 'ant-design-vue'
import { queryDataBiStatistics, queryDataBiShipMap, queryOperationalTrendsChart } from '@/api'

const timeFormat = 'YYYY-MM-DD'
const colors = ['#FCFF00', '#43A0FF', '#f2637b', '#975fe4', '#f69c3b']
const colorsLinear = ['#FCFF0000', '#43A0FF00', '#f2637b00', '#975fe400', '#f69c3b00']
const titles = ['新增订单', '新增货盘', '新增船期']
const lineOptions = (xdata, ydataArr) => {
  let series = []
  ydataArr.forEach((v, i) => {
    series.push({
      name: titles[i],
      data: v,
      type: 'line',
      smooth: 0.6,
      symbol: 'circle',
      itemStyle: {
        color: colors[i]
      },
      lineStyle: {
        color: colors[i]
      },
      areaStyle: {
        // eslint-disable-next-line no-undef
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: colors[i]
        }, {
          offset: 1,
          color: colorsLinear[i]
        }])
      }
    })
  })

  return {
    legend: {
      data: titles,
      textStyle: {
        color: 'white'
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{b}<br/>新增订单：{c0}个<br/>新增货盘：{c1}个<br/>新增船期：{c2}个'
    },
    grid: {
      top: 40,
      bottom: 40,
      left: 40,
      right: 40
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xdata,
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      splitLine: {
        lineStyle: {
          opacity: 0.2
        }
      }
    },
    series
  }
}

let _map = null
const fleetships = []
// eslint-disable-next-line no-undef
const canvasShipUtils = CanvasShipUtils

export default {
  data () {
    return {
      chartPng,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      date: '',
      time: '',
      info1: {},
      info2: {},
      orderRates: [],
      timeType: 1,
      projectData: [],
      // ship
      visible: false,
      ships: [],
      shipInfo: {}
    }
  },
  components: {
    'flot': flot
  },
  computed: {
    userName: () => store.get('userName')
  },
  methods: {
    zeroPadding (num, digit) {
      var zero = ''
      for (var i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    },
    updateTime () {
      var cd = new Date()
      this.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      this.date = this.zeroPadding(cd.getFullYear(), 4) + '-' + this.zeroPadding(cd.getMonth() + 1, 2) + '-' + this.zeroPadding(cd.getDate(), 2)
    },
    initLine (orderList) {
      let xdata = []
      let ydata1 = []
      let ydata2 = []
      let ydata3 = []
      const line = this.$echarts.init(document.getElementById('line'))
      window.addEventListener('resize', () => {
        line.resize()
      })

      orderList.forEach(v => {
        xdata.push(v.time)
        ydata1.push(v.newOrderCount) // 新增订单
        ydata2.push(v.newCargoGoodsCOunt) // 新增货盘
        ydata3.push(v.newShipDateCount) // 新增船期
      })
      line.setOption(lineOptions(xdata, [ydata1, ydata2, ydata3]))
      window.setTimeout(() => { line.resize() })
    },
    viewProject (id) {
      window.open(`/dataScreen/${id}`, '_blank')
    },
    areaShipInfo (mmsi) {
      const result = this.ships.filter(v => v.ais === mmsi)[0]
      const shipInfo = util.formatShipdata(result.shipCXW)
      if (shipInfo.lasttime != null) {
        // eslint-disable-next-line no-undef
        shipInfo.lasttime = CommUtils.dataFormat(new Date(shipInfo.lasttime), 'yyyy-MM-dd hh:mm:ss')
      } else {
        shipInfo.lasttime = '--'
      }

      shipInfo.type = canvasShipUtils.getShipTypeCN(shipInfo.shiptype)
      shipInfo.navistatus = canvasShipUtils.getDisValue(shipInfo.navistat, 'naviStatus', 'zh_CN')
      shipInfo.seaareaid = canvasShipUtils.getDisValue(shipInfo.seaareaid, 'seaArea', 'zh_CN')

      this.shipInfo = {
        ...shipInfo,
        orderId: result.orderId,
        name: result.name
      }
      this.visible = true
    },
    getManyShip (arr) {
      if (arr) this.ships = [...arr]
      else this.ships = []

      for (var i = 0, col = arr.length; i < col; i++) {
        var ship = arr[i].shipCXW
        if (ship) {
          // eslint-disable-next-line no-undef
          var cShip = new CanvasShip()
          cShip.source = ship.from
          cShip.mmsi = ship.mmsi
          cShip.name = arr[i].name || ship.name
          cShip.sog = ship.sog / 1000
          cShip.hdg = ship.hdg / 100
          cShip.cog = ship.cog / 100
          cShip.istop = true
          cShip.shiptype = 2// 船队船
          cShip.lat = ship.lat / 1000000
          cShip.lng = ship.lon / 1000000
          cShip.width = ship.width / 10
          cShip.length = ship.length / 10
          cShip.shipid = ship.shipID
          cShip.color = '#fff'
          fleetships.push(cShip)
        }
      }
      // 添加船到地图
      _map.shipsService.addFleetShips(fleetships)
    },
    handleCancel () {
      this.visible = false
    }
  },
  mounted () {
    this.updateTime()
    this.$nextTick(() => {
      // 0 时刻钟
      setInterval(this.updateTime, 1000)

      // 1 数据
      queryDataBiStatistics({}).then(rsp => {
        // 基础数据
        this.info1 = rsp.data || {}

        // 项目列表
        this.projectData = rsp.data ? rsp.data.projectList : []
      })

      // 3 订单
      const startTime = moment().subtract(30, 'd').format(timeFormat)
      const endTime = moment().subtract(1, 'd').endOf('d').format(timeFormat)
      queryOperationalTrendsChart({
        startTime,
        endTime
      }).then(rsp => {
        // 订单图
        this.initLine(rsp.data)
      })

      // 2 航线
      // eslint-disable-next-line no-undef
      _map = new ShipxyAPI.Map('map', { ak: SHIP_KEY })
      // 开启区域船服务
      // eslint-disable-next-line no-undef
      var canvasShips = ShipxyAPI.ShipService(_map, {
        enableAreaShip: false, // 区域船
        enableFleetShip: false // 船队船
      })

      const _this = this
      canvasShips.addSelectedListener(function (ship) {
        // 选中船监听
        _this.areaShipInfo(ship.mmsi)
      })
      queryDataBiShipMap({}).then(rsp => {
        this.getManyShip(rsp.data)
      })
    })
  }
}
</script>

<style lang="less" scoped>
.screenHead {
  position: relative;
  background: url(/static/images/screen1.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  height: 90px;

  h1 {
    padding: 0;
    margin: 0;
    font-size: 32px;
    height: 90px;
    line-height: 90px;
    font-weight: bold;
    color: #5bdafe;
    display: inline-block;
    background: linear-gradient(
      180deg,
      rgba(5, 134, 255, 1) 0%,
      rgba(215, 254, 255, 1) 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .userInfo {
    position: absolute;
    font-size: 1rem;
    top: 55px;
    right: 90px;
    color: white;
  }
}

.dataDisplay {
  float: left;
  .dataBox {
    position: relative;
    min-height: 250px;
    padding: 30px 30px 10px 30px;
    background: url(/static/images/dataBi/b1.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 28px;
    h2,
    p {
      font-size: 1rem;
      color: #46f6fd;
    }
    span {
      display: inline-block;
      font-size: 1rem;
      color: white;
      height: 54px;
    }

    /deep/ .ant-empty-description,
    /deep/ .ant-progress-text {
      color: white;
    }

    .dataBoxTitle {
      position: absolute;
      width: 100%;
      top: -24px;
      left: 0;
      text-align: center;
    }
  }

  .dataBox2 {
    background: url(/static/images/dataBi/b2.png) no-repeat;
    background-size: 100% 100%;
  }
  .dataBox3 {
    background: url(/static/images/dataBi/b3.png) no-repeat;
    background-size: 100% 100%;
  }
  .dataBox4 {
    background: url(/static/images/dataBi/b4.png) no-repeat;
    background-size: 100% 100%;
  }

  .orderMap {
    text-align: center;
    width: 100%;
    height: 520px;
    margin: 30px 0 0 0;

    .dataMap {
      display: inline-block;
      background: #1890ff83;
      height: 520px;
      width: 100%;
    }
  }

  .textEllipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .orderClass {
    height: 240px;
  }

  .projectList {
    font-size: 1rem;
    height: 36px;
    line-height: 36px;
  }
}
</style>

<style>
@media screen and (min-width: 1px) {
  html,
  body {
    font-size: 12px;
  }
}
@media screen and (min-width: 1367px) {
  html,
  body {
    font-size: 14px;
  }
}
@media screen and (min-width: 1601px) {
  html,
  body {
    font-size: 16px;
  }
}
@media screen and (min-width: 1921px) {
  html,
  body {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/dataBI/index.vue